import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type CloseIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const CloseIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.gray.light350,
  ...props
}: CloseIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 6L18 18"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 6L6 18"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
